module.exports = __webpack_public_path__ + "static/media/imagem-mobile.e122e003.png";